import { render, staticRenderFns } from "./SilentCallback.vue?vue&type=template&id=3a1a8886"
import script from "./SilentCallback.vue?vue&type=script&lang=js"
export * from "./SilentCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports